import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { TaskUIUserSettings } from '@mtm/task-ui-angular';
import { AuthService } from './auth.service';
import { EmitterService } from './emitter.service';
import { ProfileSettings } from '../interfaces';
import { ProfileSettingsUpdatedEvent } from '../models/events';

@Injectable({ providedIn: 'root' })
export class TaskUserSettingsProviderService {
  private readonly authService: AuthService = inject(AuthService);

  readonly settings: WritableSignal<TaskUIUserSettings> = signal<TaskUIUserSettings>(this.mapCurrent());

  constructor() {
    EmitterService.get(ProfileSettingsUpdatedEvent).subscribe((res: ProfileSettings) =>
      this.settings.set(this.map(res))
    );
  }

  private mapCurrent(): TaskUIUserSettings {
    return this.map(this.authService.getAuthUserSettings());
  }

  private map(s: ProfileSettings | null): TaskUIUserSettings {
    return {
      dateFormat: s?.dateFormat ?? 'YYYY-MM-DD',
      timeFormat: s?.timeFormat ?? '12hs',
      timeDisplay: s?.timeDisplay ?? 'HH:MM',
      timeZone: s?.timeZone ?? 'Europe/Paris',
      numberFormat: s?.numberFormat ?? 'fr-CA',
    };
  }
}
